import { Menu, MenuItem } from '@material-ui/core';
import React, { useState } from 'react';

import { ButtonV2, Text } from '~/src/dash/publicaUI';
import { extractRouteParams, navigate, RouteTargetingBidderNew } from '~/src/dash/router/routes';
import { useBaseStore } from '~/src/dash/views/base/contexts';

const buttonHeight = 36;
const buttonWidth = 116;

export const CreateNewTargetingPresetButton = () => {
  const { session, user } = useBaseStore();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // TODO: REFACTOR THIS TO BE CONTROLLED BY CONFIG ONCE CAMPAIGN IS READY
  return (
    <div>
      <ButtonV2
        small
        onClick={handleClick}
        style={{ height: `${buttonHeight}px`, width: `${buttonWidth}px` }}
      >
        + New Preset
      </ButtonV2>
      <Menu
        id='preset-menu'
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        style={{ top: buttonHeight + 10 }}
      >
        <MenuItem
          style={{ minWidth: `${buttonWidth}px` }}
          onClick={() => navigate(RouteTargetingBidderNew, extractRouteParams({ session, user }))}
        >
          <Text small>Bidder</Text>
        </MenuItem>
        {/* TODO: ADD NEW CAMPAIGN PRESET LINK WHEN READY */}
        <MenuItem style={{ minWidth: `${buttonWidth}px` }} disabled onClick={handleClose}>
          <Text small>Campaign</Text>
        </MenuItem>
      </Menu>
    </div>
  );
};
